import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toggle-buttons";
import "./../../bindings/element";
import "./../../bindings/bao-upload";
import * as ko from "knockout";
import * as $ from "jquery";
import Bao from "./../../services/bao-service";
import guid from "./../../factories/guid";
import BaoRouter from "./../../services/bao-router";
import InformationViewModel from "./../information";
import BaoDialogViewModel from "./../../factories/bao-dialog";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import TabPage from "./../../factories/tab-page";


///View Model for the Document Tab of the InformationView
class InformationDocument extends ChildTabViewModel {

    constructor(infoVM: InformationViewModel, tabPage: any) {
        super(tabPage, parent);
        this.TabPage = tabPage;
        this.InformationViewModel = ko.observable(infoVM);
        this.InformationViewModel().SubTabsSaveFn.push(() => { return this.Save(); });
        this.InformationViewModel().SubTabsCompleteCheckFn.push(() => { return this.CompleteCheck(); });
        this.DirtyFlag = this.InformationViewModel().TabPage.DirtyFlag;
        this.IsHistory(this.StringIsNullOrEmpty(this.InformationViewModel().InfoHistoryId()));
        this.PageIndex(0);
        this.PageSize(10);
        this.TotalRows(0);

        this._msgCancel = Bao.Session.GetMessage("msgCancel");
        this._msgOk = Bao.Session.GetMessage("msgOk");
        this._Subscriptions = [];
        this.InitializeDialogs();

        this.OriginalTabTitle = this.TabPage.Title();
        this.TotalRows.subscribe((value) => {
            if (value == null || value == 0) {
                this.TabPage.Title(this.OriginalTabTitle);
                return;
            }
            this.TabPage.Title(this.OriginalTabTitle + " (" + value + ")");
        });

        this._Subscriptions.push(this.InformationViewModel().InfoAttachment.subscribe(() => {
            this.UpdateReferenceDocumentCollection();
        }));

        this._Subscriptions.push(this.SelectedReferenceDocumentRow.subscribe(() => {
            this.ToggleToolbarButtons();
        }));

        this._Subscriptions.push(this.ToolbarButtons.subscribe(() => {
            this.ToggleToolbarButtons();
        }));

        this._Subscriptions.push(this.InformationViewModel().IsHistory.subscribe(() => {
            this.ToggleToolbarButtons();
        }))
    }

    public TabPage;
    public Dialog: BaoDialogViewModel;
    public LinkDialog: BaoDialogViewModel = new BaoDialogViewModel(Bao.Session.ApplicationName);

    public InformationViewModel: KnockoutObservable<InformationViewModel> = ko.observable();

    public Template: KnockoutObservable<string> = ko.observable();
    public TemplateContext: KnockoutObservable<string> = ko.observable();

    public DirtyFlag: KnockoutObservable<boolean> = ko.observable();
    public IsHistory: KnockoutObservable<boolean> = ko.observable();

    public PageIndex: KnockoutObservable<number> = ko.observable();
    public PageSize: KnockoutObservable<number> = ko.observable();
    public TotalRows: KnockoutObservable<number> = ko.observable();

    public RenderElement: KnockoutObservable<any> = ko.observable();
    public SelectedReferenceDocumentRow: KnockoutObservable<any> = ko.observable();

    public Sorting: KnockoutObservableArray<any> = ko.observableArray();
    public DocumentCollection: KnockoutObservableArray<any> = ko.observableArray();
    public ToolbarButtons: KnockoutObservableArray<any> = ko.observableArray();

    private _msgCancel: KnockoutObservable<string> = ko.observable();
    private _msgOk: KnockoutObservable<string> = ko.observable();

    private OriginalTabTitle: KnockoutObservable<string> = ko.observable();

    private _Subscriptions: KnockoutSubscription[];

    public init() {
        this.UpdateReferenceDocumentCollection();
        this.ToggleToolbarButtons();
    }

    public Refresh() {
        var def = $.Deferred();
        Bao.post("Information/ResetSession", JSON.stringify({
            sessionTabId: this.InformationViewModel().SessionTabId()
        }), () => {
            this.RefreshGrid().then(() => {
                def.resolve();
                this.InformationViewModel().TabPage.DirtyFlag(false);
            });
        });
        return def.promise();
    }

    public StringIsNullOrEmpty(string) {
        if (string === null)
            return true;
        else if (string === "")
            return true;
        else if (typeof string === "undefined")
            return true;
        return false;
    }

    public CompleteCheck() {
        return true;
    }

    //Takes the attachment list from the Info Viewmodel and fetches it in a local list und calcualtes the row count
    public UpdateReferenceDocumentCollection() {
        let infoAttachmentBuffer: Array<any> = new Array();

        this.InformationViewModel().InfoAttachment().forEach(attachment => {
            if (attachment.DeleteInRevision() === null || attachment.DeleteInRevision() > this.InformationViewModel().Revision()) {
                infoAttachmentBuffer.push(attachment);
            }
        })

        this.DocumentCollection([]);
        this.DocumentCollection(infoAttachmentBuffer);
        this.TotalRows(this.DocumentCollection().length);
    }

    public InitializeDialogs() {
        this.Dialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.Dialog.Width("450px");
        this.Dialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.Dialog.ViewModel().Description())) {
                    this.Dialog.IsLoading(true);
                    this.Dialog.ViewModel().Upload().then(() => {
                        this.Dialog.IsLoading(false);
                        this.Dialog.Close();
                        this.RefreshGrid();
                    })
                }
                else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.Dialog, this._msgCancel, () => { this.Dialog.Close(); })
        ]);

        this.LinkDialog = new BaoDialogViewModel(Bao.Session.ApplicationName);
        this.LinkDialog.Width("450px");
        this.LinkDialog.Buttons([
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgOk, () => {
                if (!Bao.Utils.String.IsNullOrEmpty(this.LinkDialog.ViewModel().Description())) {
                    this.LinkDialog.IsLoading(true);
                    let item = this.LinkDialog.ViewModel();
                    let model = ko.map.toJS(item);
                    this.AddInformationDocument(model, this.InformationViewModel().InfoId()).then(() => {
                        this.LinkDialog.IsLoading(false);
                        this.LinkDialog.Close();
                    });
                } else {
                    new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
                }
            }),
            new BaoDialogViewModel.ButtonFactory(this.LinkDialog, this._msgCancel, () => { this.LinkDialog.Close(); })
        ]);
    }

    //Opens the Dialog for attaching Documents
    public ShowInformationDocumentDialog(infoId, infoAttachmentId) {
        this.InitializeDialogs();
        return Bao.post("Information/ShowInformationDocumentDialog", JSON.stringify({
            sessionTabId: this.InformationViewModel().SessionTabId(),
            infoId: infoId,
            infoAttachmentId: infoAttachmentId
        }), (value) => {
            var vm = ko.map.fromJS(value.Model);
            vm.Upload = function () { };
            vm.SelectedFiles = ko.observableArray<string>();
            vm.IsEdit = infoAttachmentId != null;
            vm.DocumentType = 0;
            if (infoAttachmentId != null) {
                vm.UploadUrl = 'Information/UploadAttachment?sessionTabId=' + this.InformationViewModel().SessionTabId() + '&informationId=' + infoId + '&infoAttachmentId=' + infoAttachmentId;
            }
            else {
                vm.UploadUrl = 'Information/UploadAttachment?sessionTabId=' + this.InformationViewModel().SessionTabId() + '&informationId=' + infoId;
            }
            this.Dialog.ViewModel(vm);
            this.Dialog.Template(value.Message);
            this.Dialog.Open();
        });
    }

    //Opens the Dialog for attaching Links
    public ShowInformationLinkDialog(infoId, infoAttachmentId) {
        return Bao.post("Information/ShowInformationDocumentDialog", JSON.stringify({
            sessionTabId: this.InformationViewModel().SessionTabId(),
            infoId: infoId,
            infoAttachmentId: infoAttachmentId
        }), (value) => {
            var vm = ko.map.fromJS(value.Model);
            vm.IsEdit = infoAttachmentId != null;
            vm.DocumentType = 1;
            this.LinkDialog.ViewModel(vm);
            this.LinkDialog.Template(value.Message);
            this.LinkDialog.Open();
        });
    }

    //Updates the Attachment List of the Info ViewModel
    public RefreshGrid() {
        this.TabPage.IsLoading(true);
        return Bao.post("Information/SearchInformationAttachmentCollection", JSON.stringify({
            sessionTabId: this.InformationViewModel().SessionTabId(),
            infoId: this.InformationViewModel().InfoId(),
            pageIndex: this.PageIndex(),
            pageSize: this.PageSize(),
            sorting: this.Sorting()
        }), (searchResult) => {
            this.TabPage.IsLoading(false);
            this.SelectedReferenceDocumentRow(null);
            this.TotalRows(0);
            this.InformationViewModel().InfoAttachment([]);
            if (searchResult != null && searchResult.Models != null) {
                ko.map.fromJS(searchResult.Models, this.InformationViewModel().InfoAttachment);
            }
        });
    }

    public AddInformationDocument(model, infoId) {
        this.TabPage.IsLoading(true);
        return Bao.post("Information/AddInformationAttachment", JSON.stringify({
            sessionTabId: this.InformationViewModel().SessionTabId(),
            referenceDocumentModel: ko.map.toJS(model),
            infoId: infoId
        }), () => {
            this.InformationViewModel().TabPage.DirtyFlag(true);
            return this.RefreshGrid();
        });
    }

    public DeleteInformationAttachment(infoAttachmentId) {
        var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDeleteConfigurationItemReferenceDocument"), "yesno");
        this._Subscriptions.push(questionDialog.DialogResult.subscribe((result) => {
            if (result === true) {
                return Bao.post("Information/RemoveAttachment", JSON.stringify({
                    sessionTabId: this.InformationViewModel().SessionTabId(),
                    attachmentId: infoAttachmentId,
                    deleteInRevision: this.InformationViewModel().Revision()
                }), () => {
                    this.InformationViewModel().TabPage.DirtyFlag(true);
                    this.RefreshGrid();
                });
            }
        }));
    }

    public OpenAttachment = (infoAttachmentId) => {
        if (this.SelectedReferenceDocumentRow().DocumentType() == 1) {
            this.OpenLink(this.SelectedReferenceDocumentRow().Link());
        }
        else {
            window.open(window.absolutePath + 'Information/DownloadAttachment/' + infoAttachmentId);
        }
    };

    public OpenLink = (link) => {
        if (link.startsWith('http')) {
            window.open(link);
        }
        else {
            window.open('https://' + link);
        }
    }

    public ToolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "AddInformationDocument":
                this.ShowInformationDocumentDialog(this.InformationViewModel().InfoId(), null);
                break;
            case "AddInformationDocumentLink":
                this.ShowInformationLinkDialog(this.InformationViewModel().InfoId(), null);
                break;
            case "EditInformationDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    if (this.SelectedReferenceDocumentRow().DocumentType() == 1) {
                        this.ShowInformationLinkDialog(this.InformationViewModel().InfoId(), this.SelectedReferenceDocumentRow().InfoAttachmentId());
                    }
                    else {
                        this.ShowInformationDocumentDialog(this.InformationViewModel().InfoId(), this.SelectedReferenceDocumentRow().InfoAttachmentId());
                    }
                }
                break;
            case "DeleteInformationDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.DeleteInformationAttachment(this.SelectedReferenceDocumentRow().InfoAttachmentId());
                }
                break;
            case "DownloadInformationDocument":
                if (this.SelectedReferenceDocumentRow() != null) {
                    this.OpenAttachment(this.SelectedReferenceDocumentRow().InfoAttachmentId());
                }
                break;
        }
    };

    public ToggleToolbarButtons() {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button) => {
            switch (button.ActionKey()) {
                case "AddInformationDocument":
                    button.Enabled(!this.InformationViewModel().IsHistory())
                    break;
                case "AddInformationDocumentLink":
                    button.Enabled(!this.InformationViewModel().IsHistory())
                    break;
                case "EditInformationDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined && !this.InformationViewModel().IsHistory());
                    break;
                case "DeleteInformationDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() !== null && this.SelectedReferenceDocumentRow() !== undefined && !this.InformationViewModel().IsHistory());
                    break;
                case "DownloadInformationDocument":
                    button.Enabled(this.SelectedReferenceDocumentRow() != null && ko.unwrap(this.SelectedReferenceDocumentRow().DocumentType) == 0);
                    break;
            }
        });
    }
}
export default InformationDocument;